import {
  useHistory
} from "react-router-dom";
import {
  twMerge
} from "tailwind-merge";
import {
  MouseEvent,
  createElement
} from "react";

import {
  ButtonProps
} from "./Button.types";
import {
  ButtonColors,
  ButtonSize,
  ButtonVariants,
  IconSize,
  Theme
} from "./Button.theme";
import {
  LoadingIcon
} from '../../Icons';

function Button({
  startIcon,
  className,
  children,
  disabled,
  onClick,
  endIcon,
  classes,
  loading,
  variant,
  color,
  pill,
  size,
  to,
  ...props
}: ButtonProps) {

  const history = useHistory();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (!to) {
      onClick?.(event);
    } else {
      history.push(to);
    }
  };

  return (
    <button
      disabled={disabled || loading}
      onClick={handleClick}
      type="button"
      className={twMerge(
        Theme.button,
        disabled ? ButtonVariants[variant]["disabled"] : ButtonVariants[variant][color],
        disabled ? ButtonColors["disabled"] : ButtonColors[color],
        disabled && "cursor-not-allowed",
        loading && Theme.loadingButton,
        ButtonSize[size],
        pill && "rounded-full",
        classes?.button,
        className
      )}
      {...props}
    >
      {(!!loading) ? createElement(LoadingIcon, {
        className: twMerge(
          Theme.loadingIcon,
          IconSize[size],
          classes?.startIcon,
          "fill-inherit"
        )
      }) : (!!startIcon) && createElement(startIcon, {
        className: twMerge(
          Theme.startIcon,
          IconSize[size],
          classes?.startIcon
        )
      })}
      {children}
      {(!!endIcon) && createElement(endIcon, {
        className: twMerge(
          Theme.endIcon,
          IconSize[size],
          classes?.endIcon
        )
      })}
    </button>
  );
}

Button.defaultProps = {
  variant: 'contained',
  color: 'primary',
  size: 'md'
} as ButtonProps;

export { Button }
